import { imageAsset } from '@/data/sanity/fragments'
import { getMainDataOverrides, getLanguageQueryString } from '@/data/sanity/utils-language'

export const fields = `
  title,  
  ...(content) {
    ${getLanguageQueryString([
      'publishedDate',
      'link',
      'source',
      {
        name: 'logo',
        fields: imageAsset.fields,
      },
    ])}
  },
  ${getMainDataOverrides({
    objectSuffix: 'Content',
    mainObjectName: 'content',
    mainDataOverrides: ['title'],
  })}
`

export const fragment = (name: string) => `${name}{
	${fields}
}`

const exports = { fields, fragment }

export default exports
